module.exports = "https://cdn2-fs.clearscore.com/flux/images/d8137076ad44bd8052ddaffc6f3e0413.jpg";